import * as React from "react";
import styles from "./setPasswordForm/setPasswordForm.module.scss"
import Input from "../../Componnets/Input/Input";
import {useEffect} from "react";

const SetPasswordForm = (props) => {
  const [password, setPassword] = React.useState()
  const [repeatPassword, setRepeatPassword] = React.useState()
  const [allowSave, setAllowSave] = React.useState(false)
  const [passwordRequirements, setPasswordRequirements] = React.useState({
    lengthCheck: false,
    capsLetterCheck: false,
    numberCheck: false,
  })

  const mapCheckToItsTitle = () => {
    return [
      {
        checked: passwordRequirements.lengthCheck,
        title: "At least 8 characters."
      },
      {
        checked: passwordRequirements.capsLetterCheck,
        title: "A mixture of both uppercase and lowercase letters.",
      },
      {
        checked: passwordRequirements.numberCheck,
        title: "A mixture of letters and numbers.",
      },
    ]
  }

  const handleCheckPasswordRequirements = (e) => {
    const { value } = e.target
    const lengthCheck = value.length >= 8;
    const capsLetterCheck = /[A-Z]/.test(value);
    const numberCheck = /[0-9]/.test(value);

    setPasswordRequirements({
      lengthCheck,
      capsLetterCheck,
      numberCheck,
    })
  }

  useEffect(() => {
    if (props.passwordRequirements) {
      props.passwordRequirements(allowSave)
    }
  }, [allowSave])

  React.useEffect(() => {
    if (password?.length && repeatPassword?.length && !Object.keys(passwordRequirements).some(k => !passwordRequirements[k])) {
      if (password === repeatPassword) {
        setAllowSave(true)
      } else {
        setAllowSave(false)
      }
    } else {
      setAllowSave(false)
    }
  }, [password, repeatPassword])

  const handleSubmitForm = (e) => {
    e.preventDefault()
    props.handleSubmitForm(password, repeatPassword)
  }

  return (
    <div className={styles.SetPassword}>
      <div className={styles.passwordRequirements}>
        <div>
          {props.title}
        </div>
        <ul>
          {
            mapCheckToItsTitle().map((requirement, index) => (
              <li key={`${requirement.title}_${index}`} className={requirement.checked && styles.checked}>
                <span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.66667L6.28571 11.3333L4 8.66667" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
                <span>{ requirement.title }</span>
              </li>
            ))
          }
        </ul>
      </div>
      <form onSubmit={handleSubmitForm}>
        <div>
          <Input
            label={"Password"}
            placeholder={"Enter your password..."}
            onChange={(e) => {
              const val = e.target.value
              setPassword(val)
              if (props.enteredPassword) {
                props.enteredPassword(val)
              }
            }}
            value={password}
            onKeyUp={handleCheckPasswordRequirements}
            type={"password"}
          />
        </div>
        <div className={"mt-4"}>
          <Input
            label={"Repeat Password"}
            placeholder={"Repeat your password ..."}
            value={repeatPassword}
            onChange={(e) => {
              const val = e.target.value
              setRepeatPassword(val)
              if (props.enteredRepeatPassword) {
                props.enteredRepeatPassword(val)
              }
            }}
            type={"password"}
          />
        </div>
        {
          props.showSaveButton &&
            <div>
              <button className={(!allowSave || props.apiResponse === "loading") && styles.disabled}>{props.apiResponse === "loading" ? "Please wait..." : "Save"}</button>
            </div>
        }
      </form>
    </div>
  )
}

export default SetPasswordForm